<div class="home-frame" id="home">
    <div class="headline-outside">
        <div class="in-head-frame">
            <div class="headline">
                Digital<br><span class="headline-line-two">Projects &amp; Systems</span>
            </div>
            <div class="line-name-frame">
                <hr class="line">
                <div class="name orange">Lars Mensching</div>
            </div>
        </div>
    </div>
    <div class="brand-arrow-frame">
        <div class="brand">&copy; Lars Mensching 2024</div>
        <a href="#aboutMe" class="img-text-frame">            
            <div class="arrow-down" [class.no-move]="isIOS" [class.move]="!isIOS">
                <img src="assets/icons/arrow-down.png" alt="">
            </div>
            <div class="text">Scroll<br>Down</div>
        </a>
    </div>
</div>
